import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";
import { FAQS_RETAINER } from "@/lib/service-content/faqs/retainer";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/retainer";

const OFFERS = [
  ["Retainer Shopify Starter", 1495],
  ["Retainer de Mejora Continua Shopify", 2795],
  ["Retainer Growth & Engineering Shopify", 5000],
  ["Retainer de Ingeniería Shopify Plus", 9000],
] as const;

export const Route = createFileRoute("/es/retainer")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Retainer de Desarrollo Shopify: Ingeniería Senior Continua · Shugert",
    description: "Capacidad Shopify senior acotada con roadmap priorizado, contexto persistente y releases controlados. Planes desde $1,495 USD al mes.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-default-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Retainer", path: PATH }]),
      faqJsonLd(FAQS_RETAINER.es),
      {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Retainer de Ingeniería Shopify Continua",
        url: `https://shugert.com.mx${PATH}`,
        description: "Capacidad de delivery Shopify senior acotada con backlog priorizado, staging, validación y límites operativos explícitos.",
        provider: { "@type": "ProfessionalService", name: "Shugert", url: "https://shugert.com.mx" },
        areaServed: [
          { "@type": "Country", name: "United States" },
          { "@type": "Country", name: "Mexico" },
          { "@type": "Country", name: "Spain" },
        ],
        serviceType: "Ingeniería Shopify Continua",
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Niveles de Retainer Shopify",
          itemListElement: OFFERS.map(([name, price]) => ({
            "@type": "Offer",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
            category: name.includes("Plus") ? "Shopify Plus Retainer" : "Shopify Retainer",
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              priceCurrency: "USD",
              ...(price >= 5000 ? { minPrice: price } : { price }),
              unitCode: "MON",
              referenceQuantity: { "@type": "QuantitativeValue", value: 1, unitCode: "MON" },
            },
            itemOffered: { "@type": "Service", name, url: `https://shugert.com.mx${PATH}` },
          })),
        },
      },
    ],
  }),
});
